import store from "@/store";

// Kept in sync with V1__init.sql: every /client/system/* path must appear in the backend
// sys_menu tree, so if the user's menu grant doesn't include the target path they're not
// allowed to open it directly either.
export const SYSTEM_ROUTE_PREFIX = "/client/system";

export function hasPerm(code) {
  if (!code) return true;
  const u = store.state.user;
  if (!u) return false;
  // admin 不再豁免。权限完全走 sys_role_menu → perms 数组。
  return (u.perms || []).indexOf(code) !== -1;
}

export function hasRole(role) {
  const roles = (store.state.user && store.state.user.roles) || [];
  return roles.indexOf(role) !== -1;
}

// Flatten the backend menu tree into { path -> node }. Non-MENU nodes and nodes with no
// path (BUTTONs, DIRs without a landing page) are skipped.
export function menuPathMap() {
  const map = {};
  const walk = (nodes) => {
    if (!Array.isArray(nodes)) return;
    for (const n of nodes) {
      if (n && n.path && n.menuType !== "BUTTON") {
        map[n.path] = n;
      }
      if (n && n.children && n.children.length) walk(n.children);
    }
  };
  walk((store.state.user && store.state.user.menuTree) || []);
  return map;
}

export function canVisit(path) {
  if (!path) return true;
  if (hasRole("admin")) return true;
  // /client/system/** is strictly gated: only paths present in the user's menu grant pass.
  if (path.indexOf(SYSTEM_ROUTE_PREFIX) === 0) {
    return !!menuPathMap()[path];
  }
  // All other legacy pages fall back to allow-if-logged-in. Backend still gates the actual
  // /api, /v1, /amazon, ... data calls via sys_api_resource, so unauthorized access simply
  // renders empty tables / 403 alerts instead of leaking data.
  return true;
}
